export const actionTypes = {
  INIT: 'INIT',
  SET_DEALER: 'SET_DEALER',
  ADD_JOB_SET_IS_LEASE: 'ADD_JOB_SET_IS_LEASE',
  ADD_JOB_SET_IS_FLEET: 'ADD_JOB_SET_IS_FLEET',
  ADD_JOB_SET_LESSOR: 'ADD_JOB_SET_LESSOR',
  ADD_JOB_SET_CAR_REPAIR_TYPE_ID: 'ADD_JOB_SET_CAR_REPAIR_TYPE_ID',
  ADD_JOB_SET_LICENSE: 'ADD_JOB_SET_LICENSE',
  ADD_JOB_SET_MILEAGE: 'ADD_JOB_SET_MILEAGE',
  ADD_JOB_SET_INITIALS: 'ADD_JOB_SET_INITIALS',
  ADD_JOB_SET_FIRST_NAME: 'ADD_JOB_SET_FIRST_NAME',
  ADD_JOB_SET_LAST_NAME: 'ADD_JOB_SET_LAST_NAME',
  ADD_JOB_SET_EMAIL: 'ADD_JOB_SET_EMAIL',
  ADD_JOB_SET_PHONE: 'ADD_JOB_SET_PHONE',
  ADD_JOB_SET_CATEGORIES: 'ADD_JOB_SET_CATEGORIES',
  ADD_JOB_SET_SERVICES: 'ADD_JOB_SET_SERVICES',
  ADD_JOB_SET_APK: 'ADD_JOB_SET_APK',
  ADD_JOB_SET_REPLACEMENT: 'ADD_JOB_SET_REPLACEMENT',
  ADD_JOB_SET_DATE: 'ADD_JOB_SET_DATE',
  ADD_JOB_SET_COMMENT: 'ADD_JOB_SET_COMMENT',
  ADD_JOB_SET_IMAGES: 'ADD_JOB_SET_IMAGES',
  ADD_JOB_RESET: 'ADD_JOB_RESET',
  ADD_JOB_SET_COMPANY_CAR: 'ADD_JOB_SET_COMPANY_CAR',
  ADD_JOB_SET_COMPANY: 'ADD_JOB_SET_COMPANY',
  ADD_JOB_SET_PICKUP_LOCATION: 'ADD_JOB_SET_PICKUP_LOCATION',
  TOGGLE_DENIED_DIALOG: 'TOGGLE_DENIED_DIALOG',
};

export const setDealer = (value) => {
  return {type: actionTypes.SET_DEALER, value};
};

export const addJobIsLease = (value) => {
  return {type: actionTypes.ADD_JOB_SET_IS_LEASE, value};
};

export const addJobLessor = (value) => {
  return {type: actionTypes.ADD_JOB_SET_LESSOR, value};
};

export const addJobIsFleet = (value) => {
  return {type: actionTypes.ADD_JOB_SET_IS_FLEET, value};
};

export const addJobSetCarRepairTypeId = (value) => {
  return {type: actionTypes.ADD_JOB_SET_CAR_REPAIR_TYPE_ID, value};
};

export const addJobSetLicense = (value) => {
  return {type: actionTypes.ADD_JOB_SET_LICENSE, value};
};

export const addJobSetMileage = (value) => {
  return {type: actionTypes.ADD_JOB_SET_MILEAGE, value};
};

export const addJobSetCompanyCar = (value) => {
  return {type: actionTypes.ADD_JOB_SET_COMPANY_CAR, value};
};

export const addJobSetCompany = (value) => {
  return {type: actionTypes.ADD_JOB_SET_COMPANY, value};
};

export const addJobSetInitials = (value) => {
  return {type: actionTypes.ADD_JOB_SET_INITIALS, value};
};

export const addJobSetFirstName = (value) => {
  return {type: actionTypes.ADD_JOB_SET_FIRST_NAME, value};
};

export const addJobSetLastName = (value) => {
  return {type: actionTypes.ADD_JOB_SET_LAST_NAME, value};
};

export const addJobSetEmail = (value) => {
  return {type: actionTypes.ADD_JOB_SET_EMAIL, value};
};

export const addJobSetPhone = (value) => {
  return {type: actionTypes.ADD_JOB_SET_PHONE, value};
};

export const addJobSetCategories = (value) => {
  return {type: actionTypes.ADD_JOB_SET_CATEGORIES, value};
};

export const addJobSetServices = (value) => {
  return {type: actionTypes.ADD_JOB_SET_SERVICES, value};
};

export const addJobSetPackage = (value) => {
  return {type: actionTypes.ADD_JOB_SET_PACKAGE, value};
};

export const addJobSetAPK = (value) => {
  return {type: actionTypes.ADD_JOB_SET_APK, value};
};

export const addJobSetReplacement = (value) => {
  return {type: actionTypes.ADD_JOB_SET_REPLACEMENT, value};
};

export const addJobSetDate = (value) => {
  return {type: actionTypes.ADD_JOB_SET_DATE, value};
};

export const addJobSetComment = (value) => {
  return {type: actionTypes.ADD_JOB_SET_COMMENT, value};
};

export const addJobSetImages = (value) => {
  return {type: actionTypes.ADD_JOB_SET_IMAGES, value};
};

export const addJobReset = (options) => {
  return {type: actionTypes.ADD_JOB_RESET, value: options};
};

export const addJobSetPickupLocation = (value) => {
  return {type: actionTypes.ADD_JOB_SET_PICKUP_LOCATION, value};
};

export const toggleDeniedDialog = () => {
  return {type: actionTypes.TOGGLE_DENIED_DIALOG};
};
